import type { ReactNode } from "react";

/**
 * The single centred column every screen lives in. `key`ed by step from the
 * caller so React remounts it and the enter animation replays (≤100ms, FR-1.2).
 */
export function Screen({ children, wide = false }: { children: ReactNode; wide?: boolean }) {
  return (
    <div className={`nob-enter mx-auto w-full ${wide ? "max-w-2xl" : "max-w-xl"} px-6`}>
      {children}
    </div>
  );
}

/*
 * `Eyebrow`, `Title` and `Lede` stood here beside it, and are gone: the last
 * screen composed of all three was the identity card an account with no X
 * identity met, which ruling R-0826-1 made unreachable. The six screens still
 * importing this module take the column and write their own headings.
 */
